/* eslint-disable no-use-before-define,consistent-return */
// Mobile navigration init
const MobileNavigationInit = () => {
  const button = document.querySelector('[data-mob-toggle-btn]');
  const overlay = document.querySelector('[data-overlay-screen]');

  if (!button) return false;

  const menuBlock = document.querySelector('[data-header-menu]');

  if (getComputedStyle(menuBlock).visibility === 'hidden') {
    menuBlock.setAttribute('aria-hidden', true);
  }

  const toggle = () => {
    button.classList.toggle('is-active');
    menuBlock.classList.toggle('is-active');
    overlay.classList.add('Overlay--show');

    document.documentElement.classList.toggle('no-scroll');
    document.body.classList.toggle('no-scroll');

    if (menuBlock.classList.contains('is-active')) {
      menuBlock.setAttribute('aria-hidden', false);
      button.setAttribute('aria-expanded', true);

      menuBlock.style.height = `${window.innerHeight}px`;

      menuBlock.addEventListener('click', menuOnClickHandler);
    } else {
      menuBlock.setAttribute('aria-hidden', true);
      button.setAttribute('aria-expanded', false);
      overlay.classList.remove('Overlay--show');


      menuBlock.style.height = '';
      menuBlock.removeEventListener('click', menuOnClickHandler);
    }
  };

  const menuOnClickHandler = e => e.target === menuBlock && toggle();

  button.addEventListener('click', toggle);
  overlay.addEventListener('click', toggle);
};

export default MobileNavigationInit;
